import { finishApiURl } from "API/urls/finish.api";
import { axiosInstance } from "configs/axios";

export const updateFinishApi = async (payload) => {
  try {
    const response = await axiosInstance.post(finishApiURl.updateFinish, {
      ...payload,
    });
    return { data: response.data, status: response?.request?.status };
  } catch (error) {
    return {
      data: error?.response?.data || "No data",
      status: error?.response?.request?.status || "No status",
    };
  }
};
